import { render, staticRenderFns } from "./StatusAtendimentoIcone.vue?vue&type=template&id=550160ba&scoped=true"
import script from "./StatusAtendimentoIcone.vue?vue&type=script&lang=js"
export * from "./StatusAtendimentoIcone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550160ba",
  null
  
)

export default component.exports